<div [formGroup]="form">

  <!-- ===================== Fileira 1: os TRÊS editáveis =====================
       A §7 manda que abram a seção, no mesmo lugar e com os mesmos rótulos nos dois documentos,
       separados dos campos de leitura por uma régua. -->
  <div class="row">
    <!-- Desconto do documento em R$ OU em % (D5): um recalcula o outro, como valor × percentual
         no rateio de centro de custo. O rateio entre os itens é proporcional ao total de cada um. -->
    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Desconto (R$)</mat-label>
        <input matInput formControlName="valorDesconto"
          [currencyMask]="mascaraDinheiro" [readonly]="isSomenteLeitura" class="vt-num">
        <mat-hint>{{ percentualEhFonte ? 'Calculado pelo percentual' : 'Rateado entre os itens' }}</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Desconto (%)</mat-label>
        <input matInput formControlName="percentualDescontoGlobal"
          [currencyMask]="mascaraPercentual" [readonly]="isSomenteLeitura" class="vt-num">
        <mat-hint>{{ percentualEhFonte ? 'Sobre o total dos itens' : 'Equivalente ao valor informado' }}</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Frete (R$)</mat-label>
        <input matInput formControlName="valorFrete"
          [currencyMask]="mascaraDinheiro" [readonly]="isSomenteLeitura" class="vt-num">
        <mat-hint>{{ apoioFrete }}</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Despesas (R$)</mat-label>
        <input matInput formControlName="valorDespesas"
          [currencyMask]="mascaraDinheiro" [readonly]="isSomenteLeitura" class="vt-num">
        <mat-hint>{{ apoioDespesas }}</mat-hint>
      </mat-form-field>
    </div>
  </div>

  <!-- §6.5: o desconto do documento compõe com o de cada item; acima do teto do perfil, o
       salvar vai pedir liberação. Aviso, não bloqueio (decisão D1). -->
  @if (itensAcimaDoTeto > 0) {
    <app-alert-card type="warning" title="Desconto acima do limite" class="vt-alerta">
      Com o desconto do documento, {{ itensAcimaDoTeto }} {{ itensAcimaDoTeto === 1 ? 'item passa' : 'itens passam' }}
      do limite de {{ tetoDesconto }}% do seu perfil. O documento vai pedir liberação ao salvar.
    </app-alert-card>
  }

  <hr class="vt-regua">

  <!-- ===================== Fileira 2: contadores e pesos ===================== -->
  <div class="row">
    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nº de itens</mat-label>
        <input matInput [value]="totais.quantidadeDeItens" disabled class="vt-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Soma das qtdes</mat-label>
        <input matInput [value]="totais.somaDasQuantidades | abnt: 'quantidade'" disabled class="vt-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Peso bruto (kg)</mat-label>
        <input matInput [value]="totais.pesoBruto | abnt: 'quantidade'" disabled class="vt-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Peso líquido (kg)</mat-label>
        <input matInput [value]="totais.pesoLiquido | abnt: 'quantidade'" disabled class="vt-num">
      </mat-form-field>
    </div>
  </div>

  <!-- ===================== Fileira 3: dinheiro =====================
       Os tributos apurados ficam na seção Tributos (vd-tributos). -->
  <div class="row">
    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Total produtos</mat-label>
        <input matInput [value]="totais.totalDosItens | abnt: 'preco' : 2" disabled class="vt-num">
      </mat-form-field>
    </div>

    <!-- O total fecha a seção e é o único em destaque: é o número que o cliente assina. -->
    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100 vt-destaque">
        <mat-label>Total da venda</mat-label>
        <input matInput [value]="totalDoDocumento | abnt: 'preco' : 2" disabled class="vt-num">
      </mat-form-field>
    </div>
  </div>
</div>
